export const FARM_CONTEXT_STORAGE_KEY = 'shefaFarmContextOverride';
